import GameMasterDirectory from './game-master-directory'
import GameMasterCard from './game-master-card'

export default {
    GameMasterDirectory,
    GameMasterCard,
}
